var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08594 7.49988V10.9026",
    stroke: "#FF3A3A",
    strokeOpacity: 0.82,
    strokeWidth: 1.36111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80078 7.49988V10.9026",
    stroke: "#FF3A3A",
    strokeOpacity: 0.82,
    strokeWidth: 1.36111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.09741H11.8889",
    stroke: "#FF3A3A",
    strokeOpacity: 0.82,
    strokeWidth: 1.36111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36719 6.13904V11.5835C2.36719 12.7111 3.28127 13.6251 4.40885 13.6251H8.49218C9.61979 13.6251 10.5338 12.7111 10.5338 11.5835V6.13904",
    stroke: "#FF3A3A",
    strokeOpacity: 0.82,
    strokeWidth: 1.36111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39856 2.73599C4.39856 1.98427 5.00795 1.37488 5.75967 1.37488H7.12078C7.87252 1.37488 8.48188 1.98427 8.48188 2.73599V4.0971H4.39856V2.73599Z",
    stroke: "#FF3A3A",
    strokeOpacity: 0.82,
    strokeWidth: 1.36111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.da6bfc1d36227c7fb53c191c4c1b8d5b.svg";
export { ForwardRef as ReactComponent };